import React from 'react'

import contactBg from '../images/gain-bottom-shapes.svg'

function Footer() {
	return (
		<footer className='site-footer' style={{ backgroundImage: `url(${contactBg})` }}>
			<div className='site-footer__content'>
				<p>
					<small>&copy; {new Date().getFullYear()} GAIN</small>
				</p>
				<div className='social'>
					<a className='link' href='http://whatsapp.com' target='_blank' rel='noopener noreferrer'>
						<i className='icon icon-whatsapp' />
					</a>
					<a className='link' href='http://instagram.com' target='_blank' rel='noopener noreferrer'>
						<i className='icon icon-instagram' />
					</a>
					<a className='link' href='http://facebook.com' target='_blank' rel='noopener noreferrer'>
						<i className='icon icon-facebook' />
					</a>
				</div>
			</div>
			<p className='credit'>
				<small>
					Diseño y desarrollo por: BeWine &{' '}
					<a href='https://behance.net/penhold3r' target='_blank' rel='noopener noreferrer'>
						penHolder Designerd
					</a>
				</small>
			</p>
		</footer>
	)
}

export default Footer
